
import React, { useEffect, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Link from '@nmx/template/dist/cjs/componentLibrary/components/Link';

export const nmxScroll = (e, elId, isLargeUp = true) => {

  if(e){
    e.preventDefault();
  }
  // gathering desktop sticky nav height
  const headerEl = document.querySelector('#nmx-header > .nmx-container');
  const headerElHeight = headerEl?.clientHeight;
  // gathering mobile nav height
  const mobileHeaderEl = document.querySelector('.nmx-header-logo-container');
  const mobileHeaderElHeight = mobileHeaderEl?.clientHeight;
  // get targeted section element
  const el = document.getElementById(elId);
  // setting offset for desktop
  let elPosY;
  if(isLargeUp){
    elPosY = window.scrollY + el?.getBoundingClientRect().top - headerElHeight;
  }else {
    elPosY = window.scrollY + el?.getBoundingClientRect().top - mobileHeaderElHeight;
  }

  window.scroll({
    top: elPosY,
    behavior: 'smooth',
  });

  const focusableEls = Array.prototype.slice.call(el?.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.no-query), [tabindex="0"]'));
  const [firstFocusableEl] = focusableEls;
  if(firstFocusableEl){
    firstFocusableEl.focus({ preventScroll: true });
  }
};

export default ({
  ariaLabel,
  branding,
  children,
  className,
  id,
  onAfterScroll,
  targetId,
  themeType,
  variant,
}) => {

  const theme = useContext(ThemeContext);
  const largeUp = theme.largeUp();
  const [isLargeUp, setIsLargeUp] = useState(largeUp);

  useEffect(() => {
    if (largeUp !== isLargeUp) {
      setIsLargeUp(largeUp);
    }
  }, [largeUp, isLargeUp]);

  return (
    <Link
      id={id}
      className={className}
      themeType={themeType}
      branding={branding}
      variant={variant}
      onClick={(e) => {
        nmxScroll(e, targetId, isLargeUp);
        if (onAfterScroll) {
          onAfterScroll(e);
        }
      }}
      linkUrl=''
      ariaLabel={ariaLabel}>
      {children}
    </Link>
  );
};
